export default __webpack_public_path__ + "static/media/arrow_Up.8d396dd6.svg";